// extracted by mini-css-extract-plugin
export default {"taskBox":"Tasks_taskBox__Bkv8Y","title":"Tasks_title__2MYkC","taskList":"Tasks_taskList__uQdct","whiteTheme":"Tasks_whiteTheme__lZNvD"};